import script from "./ProgramsDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramsDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramsDashboard.vue?vue&type=style&index=0&id=24d3a1ea&lang=scss"

const __exports__ = script;

export default __exports__